export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5504.d6e864fe.jpg";